export function getGroupPosition(
  laneIndex: number,
  scale: number,
  baseShift: number,
  basePerPixel: number,
  groupHeight: number,
  originOffset: number,
) {
  const x = (baseShift / basePerPixel + originOffset) * scale;
  const y = laneIndex * groupHeight;

  return { x, y };
}
